import React from 'react'

const TrainingPlacement = () => {
  return (
    <div>
    <h1 style={{color:"white"}}>
     Training & Placement
    </h1>
 </div>
  )
}

export default TrainingPlacement